import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
  Type,
} from '@angular/core';
import { IconType } from '@nibtravel/shared/ui/components/icon';
import { NodeRenderer } from 'ngx-contentful-rich-text';

import { AlertType } from './alert.enum';

@Component({
  selector: 'nibtravel-alert',
  templateUrl: './alert.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertComponent implements OnInit {
  @Input() hostClass!: string;
  @Input() type!: AlertType;
  @Input() title!: string;
  @Input() withFlag = true;
  @Input() canBeClosed = false;
  @Output() alertClosed = new EventEmitter();
  @Input()
  @HostBinding('id')
  inputId!: string;

  @HostBinding('class') get class(): string {
    return `alert ${this.hostClass ?? ''}`;
  }

  /** Contentful Rich Text fields */
  @Input() richText!: Document;
  @Input() nodeRenderers!: Record<string, Type<NodeRenderer>>;

  get iconType(): string {
    switch (this.type) {
      case AlertType.ALERT:
        return IconType.Alert;
      case AlertType.INFO:
        return IconType.Info;
      case AlertType.SUCCESS:
        return AlertType.SUCCESS;
      case AlertType.WARNING:
        return IconType.Warning;
    }
  }

  ngOnInit(): void {
    if (this.type === null || this.type === undefined) {
      throw new TypeError('The input ‘Type’ is required');
    }
  }

  close(): void {
    this.alertClosed.emit();
  }
}
